import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ targetDate, expiredText = "EXPIRED", prefix = "Ends in: " }) => {
    const calculateTimeLeft = () => {
        const difference = +new Date(targetDate) - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                d: Math.floor(difference / (1000 * 60 * 60 * 24)),
                h: Math.floor((difference / (1000 * 60 * 60)) % 24),
                m: Math.floor((difference / 1000 / 60) % 60),
                s: Math.floor((difference / 1000) % 60),
            };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    const timerComponents = [];

    Object.keys(timeLeft).forEach((interval) => {
        if (!timeLeft[interval] && interval !== 's' && interval !== 'm') {
            return;
        }

        timerComponents.push(
            <span key={interval}>
                {timeLeft[interval]}{interval}{" "}
            </span>
        );
    });

    return (
        <span className="flex items-center gap-1">
            {timerComponents.length ? (
                <>
                    <span className="font-bold">{prefix}</span>
                    <span className="font-black animate-pulse text-indigo-600">
                        {timerComponents}
                    </span>
                </>
            ) : (
                <span className="font-black text-red-600 uppercase tracking-widest">{expiredText}</span>
            )}
        </span>
    );
};

export default CountdownTimer;
